// @ts-ignore esModuleInterop
import React from 'react'
// @ts-ignore no types
import { Alert, Button } from '@adc/ui-adc'
import * as blueprint from '@adc/blueprint'
import { type AuctionBlueprintOnlineReactiveArgs } from '@adc/blueprint'
import {
  NON_ONLINE_BID_DEPOSIT_LEARN_MORE_URL,
  ONLINE_BID_DEPOSIT_LEARN_MORE_URL,
} from 'common/statics'

interface BidDepositRequiredMessageProps {
  enableBidDepositRequiredMessage: boolean
  featureFlags: any
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
  shouldShowSealedBidTreatment?: boolean
}

// TODO: once this doesn't need to get listing from property.listing from firstlookmodalbutton, update this to get listing from context
export const BidDepositRequiredMessage = ({
  enableBidDepositRequiredMessage,
  featureFlags,
  listing,
  shouldShowSealedBidTreatment = false,
}: BidDepositRequiredMessageProps) => {
  let shouldShowBidDepositRequiredMessage =
    enableBidDepositRequiredMessage &&
    listing.online_auction_segment?.configuration
      ?.is_registration_deposit_required_enabled
  let bidDeposit = ' of $999 '
  let learnMoreURL = NON_ONLINE_BID_DEPOSIT_LEARN_MORE_URL
  let bidDepositTitle = `A ${
    shouldShowSealedBidTreatment ? '' : 'Bid '
  }Deposit${bidDeposit}is required`
  let bidDepositMessage =
    ' to complete the registration process; activation may take up to 2 business days. '

  if (featureFlags['fe.resi.enable-wallet']) {
    shouldShowBidDepositRequiredMessage =
      enableBidDepositRequiredMessage &&
      listing.current_user_bid_deposit_requirements
        ?.is_registration_deposit_applicable

    bidDeposit = listing.current_user_bid_deposit_requirements
      ?.absolute_amount_required
      ? ` of ${blueprint.utils.formatMoney(
          listing.current_user_bid_deposit_requirements
            ?.absolute_amount_required,
          {},
          true
        )} `
      : ' '
    learnMoreURL = ONLINE_BID_DEPOSIT_LEARN_MORE_URL
    bidDepositTitle = `A ${
      shouldShowSealedBidTreatment ? '' : 'Bid '
    }Deposit${bidDeposit}is required\n`
    bidDepositMessage = 'to register for this property.'
  }

  return shouldShowBidDepositRequiredMessage ? (
    <Alert
      style={{ textAlign: 'initial' }}
      role='info'
      header={`${bidDepositTitle} ${bidDepositMessage}`}
      slots={{
        action: () => (
          <Button
            data-elm-id='bid_deposit_learn_more'
            tag='a'
            link={learnMoreURL}
            target='_blank'
            rel='noreferrer'
          >
            Learn More
          </Button>
        ),
      }}
    />
  ) : null
}
